import React from 'react';
import { CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';

const ELEMENT_STYLE = {
  style: {
    base: {
      fontSize: '16px',
      fontFamily: "'Plus Jakarta Sans', 'Noto Sans TC', sans-serif",
      color: '#1a1a1a',
      '::placeholder': {
        color: '#999',
      },
    },
    invalid: {
      color: '#ef4444',
    },
  },
};

const fieldStyle = (disabled) => ({
  padding: '14px 16px',
  border: '1px solid #e8e8e8',
  borderRadius: '4px',
  background: disabled ? '#f5f5f5' : '#fff',
  transition: 'all 0.3s ease',
});

const StripeCardInput = ({ disabled }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
    <div style={fieldStyle(disabled)}>
      <CardNumberElement options={{ ...ELEMENT_STYLE, disabled, placeholder: '卡號' }} />
    </div>
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
      <div style={fieldStyle(disabled)}>
        <CardExpiryElement options={{ ...ELEMENT_STYLE, disabled }} />
      </div>
      <div style={fieldStyle(disabled)}>
        <CardCvcElement options={{ ...ELEMENT_STYLE, disabled }} />
      </div>
    </div>
  </div>
);

export default StripeCardInput;
